import { useState, useEffect } from 'react';

export function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      const offset = 80;
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;
      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  };

  const handleCallClick = (e: React.MouseEvent) => {
    e.preventDefault();
    window.location.href = 'tel:+14433980720';
  };

  return (
    <>
      <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-white shadow-md' : 'bg-transparent'}`}>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-start justify-between py-4">
            <div className="flex items-start pt-1">
              <img 
                src="https://static.readdy.ai/image/c7e9a960a8d98f6675d66fd16b902a96/d6911449641f81f9a11579f3e218d085.png" 
                alt="Greener Eco Landscaping LLC" 
                className="h-16 sm:h-20 md:h-24 lg:h-28 w-auto object-contain"
              />
            </div>

            <div className="hidden md:flex items-center space-x-8 pt-3">
              <button 
                onClick={() => scrollToSection('services')}
                className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${isScrolled ? 'text-gray-700 hover:text-[#4A7C2C]' : 'text-white hover:text-[#4A7C2C]'}`}
              >
                Services
              </button>
              <button 
                onClick={() => scrollToSection('gallery')}
                className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${isScrolled ? 'text-gray-700 hover:text-[#4A7C2C]' : 'text-white hover:text-[#4A7C2C]'}`}
              >
                Gallery
              </button>
              <button 
                onClick={() => scrollToSection('about')}
                className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${isScrolled ? 'text-gray-700 hover:text-[#4A7C2C]' : 'text-white hover:text-[#4A7C2C]'}`}
              >
                About
              </button>
              <button 
                onClick={() => scrollToSection('contact')}
                className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${isScrolled ? 'text-gray-700 hover:text-[#4A7C2C]' : 'text-white hover:text-[#4A7C2C]'}`}
              >
                Contact
              </button>
            </div>

            <div className="hidden lg:flex items-center gap-6">
              <a 
                href="tel:+14433980720"
                className={`flex items-center gap-2 font-semibold text-lg transition-colors ${
                  isScrolled ? 'text-[#2D5016] hover:text-[#4A7C2C]' : 'text-white hover:text-white/80'
                }`}
              >
                <i className="ri-phone-fill text-xl"></i>
                443-398-0720
              </a>
            </div>

            <button 
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              className={`md:hidden p-3 rounded-lg transition-colors cursor-pointer z-50 ${isScrolled ? 'text-gray-700 hover:bg-gray-100' : 'text-white hover:bg-white/10'}`}
              aria-label="Toggle menu"
            >
              <i className={`${isMenuOpen ? 'ri-close-line' : 'ri-menu-line'} text-3xl`}></i>
            </button>
          </div>
        </div>
      </nav>

      {/* Mobile Menu */}
      <div className={`fixed inset-0 bg-white z-40 transform transition-transform duration-300 lg:hidden ${isMenuOpen ? 'translate-x-0' : 'translate-x-full'}`}>
        <div className="flex flex-col p-6 space-y-4">
          {['Services', 'About', 'Gallery', 'Contact'].map((item) => (
            <a
              key={item}
              href={`#${item.toLowerCase()}`}
              onClick={() => setIsMenuOpen(false)}
              className="text-gray-700 hover:text-[#4A7C2C] font-semibold text-lg py-3 border-b border-gray-100 transition-colors cursor-pointer"
            >
              {item}
            </a>
          ))}
        </div>

        <div className="px-6 py-4 border-t border-gray-100">
          <a 
            href="tel:+14433980720"
            className="flex items-center justify-center gap-2 text-[#2D5016] font-semibold text-lg py-3"
          >
            <i className="ri-phone-fill text-xl"></i>
            443-398-0720
          </a>
        </div>
      </div>
    </>
  );
}
